import React, {useMemo} from 'react';
import {connect} from "react-redux";
import {
  HIDE_MENU_WITH_NO_FEATURES,
  SIDEBAR_NAVIGATION_3D_BATHROOM_CABINET_BUTTONS,
  SIDEBAR_NAVIGATION_3D_CABINET_BUTTONS,
  SIDEBAR_NAVIGATION_BATHROOM_CABINET_BUTTONS,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS,
} from "../../../../constants";
import {injectIntl} from "react-intl";
import $ from "jquery";
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

import {addChangeValuePopup, setSQFTActiveButton, setSQFTMenuOpened} from "../../../../../../actions/sqftMenuFunctions";
import config from "../../../canvas/store/sqftConfig";
import {
  handleResetClick, handleResizeClick, handleRotateClick, handleSpacerClick, handleWallClick, is3DMode,
  resetEvents
} from "../../NavigationHelper";
import useFetchFeatures from "../../../../hocs/useFetchFeatures";
import LoadingSpinner from "../../../../../ui/loadingSpinner";
import {getIsBathroom} from "../../../../../kvComponent/navigation/countertopSwitchers";
import {getCurrentLayout} from "../../../../../appLayout";
import {getFeatureGroupName} from "../../../../../../misc/helpers";
import {hideSqftTooltip, showSqftTooltip} from "../../../../../../actions/sqftTooltipFunctions";

const SqftToolMenuCabinet = (props) => {
  const {
    activeButton,
    menuOpened,
    setSQFTActiveButton,
    setSQFTMenuOpened,
    fabricatorData,
    intl,
    showSqftTooltip,
    hideSqftTooltip
  } = props;

  let buttons = getIsBathroom()
    ? is3DMode()
      ? { ...SIDEBAR_NAVIGATION_3D_BATHROOM_CABINET_BUTTONS }
      : { ...SIDEBAR_NAVIGATION_BATHROOM_CABINET_BUTTONS }
    : is3DMode()
      ? { ...SIDEBAR_NAVIGATION_3D_CABINET_BUTTONS }
      : { ...SIDEBAR_NAVIGATION_CABINET_BUTTONS };

  const expanded = activeButton
    && menuOpened !== "bumpout"
    && (menuOpened === "move" || Object.keys(buttons).some(buttonKey => menuOpened === buttonKey));

  const partIds = useMemo(() => HIDE_MENU_WITH_NO_FEATURES, []);
  const { featuresData, isLoading } = useFetchFeatures(partIds, "", true);

  // Object to store button states (enabled/disabled) and disable reason
  const buttonStates = {};
  const buttonDisableReasons = {};

  // Filter buttons and determine their states
  if (!isLoading && featuresData) {
    buttons = Object.keys(buttons).reduce((newButtons, buttonKey) => {
      let shouldRemove = false;
      let isDisabled = false;
      let disableReason = 'not_available'; // default reason

      // Check for hinge button
      if (buttonKey === SIDEBAR_NAVIGATION_CABINET_BUTTONS.hinge) {
        const hingeData = featuresData.hinge;
        if (!hingeData || !hingeData.allNavItems || hingeData.allNavItems.length === 0) {
          shouldRemove = true;
        } else if (hingeData.rows.length === 0) {
          isDisabled = true;
          disableReason = hingeData.wasFilteredByAR3D ? 'missing_3d_models' : 'not_available';
        }
      }

      // Check for tall cabinet button
      if (buttonKey === SIDEBAR_NAVIGATION_CABINET_BUTTONS.tall ||
        buttonKey === SIDEBAR_NAVIGATION_3D_CABINET_BUTTONS.tall_cabinet) {
        const tallData = featuresData.tall_cabinet;
        if (!tallData || !tallData.allNavItems || tallData.allNavItems.length === 0) {
          shouldRemove = true;
          if (!tallData?.rows?.length) {
            console.log("features with 3d models wasn't found for the tall cabinets");
          }
          if (!tallData?.featureGroup) {
            console.log("featuregroup tall cabinets wasn't found");
          }
        } else if (tallData.rows.length === 0) {
          isDisabled = true;
          disableReason = tallData.wasFilteredByAR3D ? 'missing_3d_models' : 'not_available';
        }
      }

      // Check for end panel button
      if (buttonKey === SIDEBAR_NAVIGATION_CABINET_BUTTONS.end_panel) {
        const hasAnyAllNavItems =
          (featuresData.wall_door_end_accessory?.allNavItems?.length > 0) ||
          (featuresData.base_door?.allNavItems?.length > 0) ||
          (featuresData.island_panel?.allNavItems?.length > 0) ||
          (featuresData.refridgerator_panel?.allNavItems?.length > 0);

        const hasAnyRows =
          (featuresData.wall_door_end_accessory?.rows?.length > 0) ||
          (featuresData.base_door?.rows?.length > 0) ||
          (featuresData.island_panel?.rows?.length > 0) ||
          (featuresData.refridgerator_panel?.rows?.length > 0);

        if (!hasAnyAllNavItems) {
          shouldRemove = true;
        } else if (!hasAnyRows) {
          isDisabled = true;
          // Check if any of them was filtered by AR3D
          const wasFilteredByAR3D =
            featuresData.wall_door_end_accessory?.wasFilteredByAR3D ||
            featuresData.base_door?.wasFilteredByAR3D ||
            featuresData.island_panel?.wasFilteredByAR3D ||
            featuresData.refridgerator_panel?.wasFilteredByAR3D;
          disableReason = wasFilteredByAR3D ? 'missing_3d_models' : 'not_available';
        }
      }

      // Check for crown_molding button
      if (buttonKey === SIDEBAR_NAVIGATION_CABINET_BUTTONS.crown_molding) {
        const crownData = featuresData.crown_molding;
        if (!crownData || !crownData.allNavItems || crownData.allNavItems.length === 0) {
          shouldRemove = true;
        } else if (crownData.rows.length === 0) {
          isDisabled = true;
          disableReason = crownData.wasFilteredByAR3D ? 'missing_3d_models' : 'not_available';
        }
      }

      if (shouldRemove) {
        return newButtons;
      }

      buttonStates[buttonKey] = isDisabled;
      buttonDisableReasons[buttonKey] = disableReason;
      newButtons[buttonKey] = buttons[buttonKey];
      return newButtons;
    }, {});
  }

  const handleButtonClick = (buttonKey) => {
    // Prevent clicking on disabled buttons
    if (buttonStates[buttonKey]) {
      return;
    }

    setSQFTMenuOpened(buttonKey);
    setSQFTActiveButton(buttonKey);
    config.workspace.menuItemActive = buttonKey;
    resetEvents();
    switch (buttonKey) {
      case SIDEBAR_NAVIGATION_CABINET_BUTTONS.move:
        setSQFTMenuOpened('');
        break;
      case SIDEBAR_NAVIGATION_CABINET_BUTTONS.resize:
        setSQFTMenuOpened('');
        setSQFTActiveButton(SIDEBAR_NAVIGATION_CABINET_BUTTONS.resize);
        handleResizeClick();
        break;
      case SIDEBAR_NAVIGATION_CABINET_BUTTONS.rotate:
        handleRotateClick();
        break;
      case SIDEBAR_NAVIGATION_CABINET_BUTTONS.spacer:
        setSQFTMenuOpened('');
        setSQFTActiveButton(SIDEBAR_NAVIGATION_CABINET_BUTTONS.spacer);
        handleSpacerClick();
        break;
      case SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall:
        setSQFTActiveButton(SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall);
        handleWallClick();
        break;
      case SIDEBAR_NAVIGATION_3D_CABINET_BUTTONS.top_cabinet:
      case SIDEBAR_NAVIGATION_3D_CABINET_BUTTONS.bottom_cabinet:
      case SIDEBAR_NAVIGATION_3D_CABINET_BUTTONS.tall_cabinet:
        setSQFTMenuOpened(buttonKey);
        break;
      case 'reset':
        handleResetClick();
        break;
    }

    $('.lightbox-option-selected').removeClass('lightbox-option-selected');
  };

  const handleMouseEnter = (event, buttonKey) => {
    if (buttonStates[buttonKey]) {
      const targetRect = event.currentTarget.getBoundingClientRect();
      const featureName = getButtonName(buttonKey);
      const disableReason = buttonDisableReasons[buttonKey];

      // Different messages based on disable reason
      let title, description;
      if (disableReason === 'missing_3d_models') {
        title = `${featureName} ${intl.formatMessage({ id: "sqft.navigation.missing_3d_models_title" })}`;
        description = `${featureName} ${intl.formatMessage({ id: "sqft.navigation.missing_3d_models_description" })}`;
      } else {
        title = `${featureName} ${intl.formatMessage({ id: "sqft.navigation.not_available_title" })}`;
        description = `${featureName} ${intl.formatMessage({ id: "sqft.navigation.not_available_description" })}`;
      }

      showSqftTooltip({
        title,
        description,
        icon: <AutoFixHighIcon />,
        position: 'right',
        targetRect
      });
    }
  };

  const handleMouseLeave = () => {
    hideSqftTooltip();
  };

  const getButtonName = (activeButton) => {
    const layout = getCurrentLayout();
    const buttonFeatureGroup = layout.getFeatureGroupByPartId(activeButton);
    if (buttonFeatureGroup) {
      return getFeatureGroupName(buttonFeatureGroup, intl, fabricatorData);
    }

    return intl.formatMessage({ id: "sqft.navigation.submenu." + activeButton });
  };

  return (
    <nav className={"navigation side" + (expanded ? " expanded" : "")} data-side="navigation">
      <div className="navigation-list">
        {isLoading
          ? <LoadingSpinner/>
          : !expanded ? null : Object.keys(buttons).map((buttonKey) => {
            const isDisabled = buttonStates[buttonKey];

            return (
              <button
                key={buttonKey}
                className={
                  "animated fadeInUp button button--" + buttonKey +
                  (isDisabled ? " button--disabled" : "")
                }
                onClick={() => handleButtonClick(buttonKey)}
                onMouseEnter={(e) => handleMouseEnter(e, buttonKey)}
                onMouseLeave={handleMouseLeave}
              >
                  <span className="button-text">
                    {getButtonName(buttonKey)}
                  </span>
              </button>
            );
          })}
      </div>
    </nav>
  );
};

const mapStateToProps = (store) => ({
  menuOpened: store.sqftMenuState.menuOpened,
  activeButton: store.sqftMenuState.activeButton,
  fabricatorData: store.fabricatorState,
});

const mapDispatchToProps = {
  setSQFTMenuOpened,
  setSQFTActiveButton,
  addChangeValuePopup,
  showSqftTooltip,
  hideSqftTooltip,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftToolMenuCabinet)
);
